var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('div',{staticClass:"small-action"},[_vm._v(" "+_vm._s(_vm.habit.get('smallAction'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }